module.exports = __webpack_public_path__ + "static/media/logo_dark.99996c90.png";